import React from "react";
import Complaints from "../modules/Complaints/Complaints";

export default function ComplaintsPage() {
  return <Complaints />;
}